// Google Analytics (gtag.js). Loads ONLY in a production build so dev traffic never hits the
// property; every function is a safe no-op when gtag was never injected (dev, or an ad-blocker).
// ponytail: measurement id hardcoded — the platform owns one GA property. Move to VITE_GA_ID only
// if a second property is ever needed.
const GA_ID = 'G-HQJL32ZJW2'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

export function initAnalytics() {
  if (!import.meta.env.PROD) return

  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(s)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments)
  }
  window.gtag('js', new Date())
  // send_page_view:false — the initial view is sent by trackPageView on mount, so gtag's own
  // auto page_view would otherwise double-count the landing page.
  window.gtag('config', GA_ID, { send_page_view: false })
}

export function trackPageView(path: string) {
  window.gtag?.('event', 'page_view', { page_path: path })
}
